const PREFIX = 'entra.ns.nl/';

// The two entra.ns.nl annotations rendered on the user profile card, in render
// order. Only these two keys are ever surfaced; every other entra.ns.nl field
// (company-name, office-location, the sensitive employee-id, ...) is ignored.
//
// These keys must match the annotations the msgraph user-sync emits: the
// producer is packages/backend/src/modules/msgraphTopaasMembership.ts
// (ENTRA_USER_FIELD_MAP). If the producer stops emitting job-title or
// department, this card silently renders nothing. That producer carries a
// contract test asserting both keys stay emitted so the two sides cannot drift
// apart unnoticed.
const ROLE_FIELDS = [
  { key: 'job-title', label: 'Functie' },
  { key: 'department', label: 'Afdeling' },
] as const;

export type RoleFieldKey = (typeof ROLE_FIELDS)[number]['key'];

export interface RoleField {
  key: RoleFieldKey;
  label: string;
  value: string;
}

/**
 * Extract the Functie (job title) and Afdeling (department) role fields from an
 * entity's annotations, in that fixed order. A field is included only when its
 * `entra.ns.nl/<key>` annotation holds a non-empty value after trimming; empty
 * or whitespace-only values are dropped so no blank row is rendered. No other
 * annotation key is ever returned.
 */
export function extractRoleFields(
  annotations: Record<string, string> | undefined,
): RoleField[] {
  if (!annotations) {
    return [];
  }

  const fields: RoleField[] = [];
  for (const { key, label } of ROLE_FIELDS) {
    const value = annotations[`${PREFIX}${key}`]?.trim();
    if (value) {
      fields.push({ key, label, value });
    }
  }
  return fields;
}
